import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Reveal, Item, MaskLines } from "@/components/Reveal";
import Magnetic from "@/components/Magnetic";
import { FAQ as qa } from "@/lib/faq";
import { ArrowRight } from "lucide-react";

export default function Questions() {
  return (
    <div data-testid="page-questions">
      <Seo
        title="Questions · AUT labs"
        description="Plain answers about AUT labs custom software, ERP and CRM systems, automation, AI agents, ownership, data, costs and how projects begin."
        faq={qa}
      />

      {/* Intro */}
      <section className="border-b border-ink col-rules">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-24">
          <Reveal className="grid grid-cols-1 md:grid-cols-12">
            <div className="md:col-span-8 lg:col-span-7">
              <Item as="p" className="eyebrow mb-6">Questions</Item>
              <h1 className="display text-[36px] md:text-[64px] lg:text-[76px] leading-[0.98]">
                <MaskLines lines={["The questions people", "usually ask first."]} />
              </h1>
              <Item as="p" className="mt-8 max-w-xl text-lg text-ink/80">
                Plain answers about what we build, what changes, what stays in your control
                and what happens before you spend anything.
              </Item>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Q&A rows */}
      <section className="border-b border-ink" data-testid="qa-rows">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8">
          <div className="border-t border-ink">
            {qa.map((row, i) => (
              <Reveal
                key={i}
                className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 border-b border-ink items-start"
              >
                <Item className="md:col-span-5">
                  <h2 className="display text-2xl md:text-[34px] leading-[1.08]" data-testid={`qa-q-${i}`}>{row.q}</h2>
                </Item>
                <Item className="md:col-span-7 md:pt-2">
                  <p className="text-lg text-ink/85" data-testid={`qa-a-${i}`}>{row.a}</p>
                </Item>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section data-testid="questions-cta">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-24">
          <Magnetic>
            <Link to="/book" className="pill pill-cobalt" data-testid="questions-book-btn">
              Book a 15-minute call <ArrowRight size={16} />
            </Link>
          </Magnetic>
        </div>
      </section>
    </div>
  );
}
